// extracted by mini-css-extract-plugin
export default {"wrapper":"PostPage_wrapper__24UiI","postCardWrapper":"PostPage_postCardWrapper__i6hdd"};